/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { MenuComponent } from '../../../../../../_metronic/assets/ts/components'
import { ID, KTSVG, QUERIES } from '../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { deletePayment, rollbackPayment } from '../../core/_requests'
import { FormattedMessage } from 'react-intl'
import toast from 'react-hot-toast'
import Swal from 'sweetalert2'

type Props = {
  id: ID
  status: string // Status prop for conditionally rendering buttons
}

const PaymentActionsCell: FC<Props> = ({ id, status }) => {
  const { setItemIdForUpdate } = useListView()
  const { query } = useQueryResponse()
  const queryClient = useQueryClient()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])
  const openEditModal = () => {
    setItemIdForUpdate(id)
  }

  const deleteItem = useMutation(() => deletePayment(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      toast.success('Payment deleted successfully', { position: 'top-right' })
    },
    onError: () => {
      toast.error('Payment deletion failed!', { position: 'top-right' })
    },
  })

  const rollbackItem = useMutation(() => rollbackPayment(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      toast.success('Payment rollback successful', { position: 'top-right' })
    },
    onError: () => {
      toast.error('Rollback failed!', { position: 'top-right' })
    },
  })

  const confirmDelete = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this payment!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    })

    if (result.isConfirmed) {
      deleteItem.mutate()
    }
  }

  const confirmRollback = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You want to rollback this payment!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, rollback it!',
    })

    if (result.isConfirmed) {
      rollbackItem.mutate()
    }
  }

  return (
    <>
      <a
        href='#'
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <FormattedMessage id='TABLE.GENERAL.ACTION' />
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>

      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        {/* Show Edit & Rollback only if not rollbacked */}
        {status !== 'rollback' && (
          <>
            {/* begin::Edit */}
            <div className='menu-item px-3'>
              <a className='menu-link px-3' onClick={openEditModal}>
                <FormattedMessage id='TABLE.GENERAL.EDIT' />
              </a>
            </div>

            {/* begin::Rollback */}
            <div className='menu-item px-3'>
              <a
                className='menu-link px-3'
                data-kt-payments-table-filter='rollback_row'
                onClick={async () => await confirmRollback()}
              >
                <FormattedMessage id='TABLE.GENERAL.ROLLBACK' defaultMessage={"کنسل پرداخت"} />
              </a>
            </div>
          </>
        )}

        {/* Show Delete (Remove) Always */}
        <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            data-kt-payments-table-filter='delete_row'
            onClick={async () => await confirmDelete()}
          >
            <FormattedMessage id='TABLE.GENERAL.DELETE' />
          </a>
        </div>
      </div>
      {/* end::Menu */}
    </>
  )
}

export { PaymentActionsCell }
